// Action Constants

export enum ActionConstant {
	GET_TOAST = 'FILE://TOAST/GET_TOAST',
	CLEAR_ALL = 'FILE://TOAST/CLEAR_ALL',
	BEFORE_SEND = 'FILE://TOAST/BEFORE_SEND',
	AFTER_SEND = 'FILE://TOAST/AFTER_SEND',
}

// Action Types

export interface GetToastType {
	type: ActionConstant.GET_TOAST;
	isMessage: boolean;
	messageType: string;
	messageContent: Record<string, unknown>;
}

export interface GetClearType {
	type: ActionConstant.CLEAR_ALL;
}

export interface GetbeforeSendType {
	type: ActionConstant.BEFORE_SEND;
}

export interface GetafterSendType {
	type: ActionConstant.AFTER_SEND;
}

export type ActionType = GetToastType | GetClearType | GetbeforeSendType | GetafterSendType;

// State Types

export interface InitialState {
	isMessage: boolean;
	messageType: string;
	messageContent: Record<string, unknown>;
	beforeSend: boolean;
}
